interface Kpis {
    rowOrderId: number;
    documentStatusCode?: string;
    documentStatusDesc: string;
    balance: number;
    numItems: number;
}

export interface AccountSummaryKpis {
    kpis: Kpis[];
}
